import urlConfig from 'Url';
import { toQueryString } from 'Utils';
import { isEmpty } from 'lodash/lang';
import { getUserInfo } from '../../../modules/actions';

export const SELECT_STYLE = 'SELECT_STYLE';
export const CHANGE_AUTH = 'CHANGE_AUTH';
export const WAY = 'WAY';
export const SAVE_QUERY = 'SAVE_QUERY';
export const GET_TICKET_LIST = 'GET_TICKET_LIST';
export const GET_ESAY_TICKET_LIST = 'GET_ESAY_TICKET_LIST';
export const GET_MORE_TICKET_LIST = 'GET_MORE_TICKET_LIST';
export const GET_SS_TICKET_LIST = 'GET_SS_TICKET_LIST';
export const GET_WX_TICKET_LIST = 'GET_WX_TICKET_LIST';
export const GET_INTREATMENTBACK = 'GET_INTREATMENTBACK';
export const GET_USER_STATUS = 'GET_USER_STATUS';
export const GET_FACECHECKMOREQUERY_SWITCH = 'GET_FACECHECKMOREQUERY_SWITCH';
export const SAVE_FACECHECKMOREQUERY_CHANNEL =
  'SAVE_FACECHECKMOREQUERY_CHANNEL';
export const QUERY_UPPPAY_RESULT = 'QUERY_UPPPAY_RESULT';
export const SAVE_LGOO = 'SAVE_LGOO';


export function selectTabStyle(data) {
  return { type: SELECT_STYLE, data };
}

export function changeAuth(data) {
  return { type: CHANGE_AUTH, data };
}

export function saveWay(data) {
  return { type: WAY, data };
}

export function saveQuery(data) {
  return { type: SAVE_QUERY, data };
}
export function facecheckmorequeryswitch(data) {
  return { type: GET_FACECHECKMOREQUERY_SWITCH, data };
}
export function facecheckmorequerychannel(data) {
  return { type: SAVE_FACECHECKMOREQUERY_CHANNEL, data };
}

export function saveflightLogo(data) {
  return { type: SAVE_LGOO, data };
}


export function reqTicketList(data, urlParams = {}) {
  return (dispatch, getState) => {
    const { easyLoginQuery, updateDetail } = getState();
    let obj = {
      pageSize: 5,
      startIndex: data.startIndex,
    };
    let type = '',
      url = ''; // urlParams.moreQueryParams ? urlParams.moreQueryParams : { ...easyLoginQuery };
    if (urlParams.moreQuery && updateDetail.faceCheckSwitch) {
      // 更多客票查询
      type = GET_MORE_TICKET_LIST;
      url = urlConfig.getMoreTicektList;
      obj = Object.assign({}, obj, easyLoginQuery);
      delete obj.easylogin;
    } else if (urlParams.type === 'B' && urlParams.ticketNo) {
      // 扫登机牌查询
      type = GET_WX_TICKET_LIST;
      url = urlConfig.getWXTicektList;
      obj.tktRegisterCode = urlParams.registerCode || urlParams.tktRegisterCode;
      obj.queryNo = urlParams.ticketNo;
      if (urlParams.name && urlParams.name.indexOf('/') !== -1) {
        obj.familyName = urlParams.name.split('/')[0];
        obj.givenName = urlParams.name.split('/')[1];
      } else {
        obj.familyName = urlParams.name;
      }
    } else if (urlParams.channel === 'ss') {
      // ss简易
      type = GET_SS_TICKET_LIST;
      url = urlConfig.getSsTicektList;
      obj.tktRegisterCode = urlParams.registerCode || urlParams.tktRegisterCode;
      obj.queryNo = urlParams.ticketNo;
      if (urlParams.name && urlParams.name.indexOf('/') !== -1) {
        obj.familyName = urlParams.name.split('/')[0];
        obj.givenName = urlParams.name.split('/')[1];
      } else {
        obj.familyName = urlParams.name;
      }
    } else if (easyLoginQuery.easylogin) {
      // 简易登录查询
      type = GET_ESAY_TICKET_LIST;
      url = urlConfig.getEasyTicektList;
      obj = Object.assign({}, obj, easyLoginQuery);
      delete obj.easylogin;
    } else {
      // 可退改查询
      type = GET_TICKET_LIST;
      url = urlConfig.getTicektList;
      obj.queryArg = data.queryArg;
    }
    return dispatch({
      type,
      payload: {
        request: {
          url: `${url}${isEmpty(urlParams) ? '' : `?${toQueryString(urlParams)}`
            }`,
          method: 'post',
          data: obj,
        },
      },
    }).then(data => {
      dispatch(getUserInfo());
      return data;
    });
  };
}

// 处理中、已退改
export function reqIntreatmentBack(data, urlParams = {}, closeLoading = false) {
  return {
    type: GET_INTREATMENTBACK,
    closeLoading,
    payload: {
      request: {
        url: urlConfig.getIntreatmentBack + '?' + new Date().getTime(),
        method: 'post',
        data,
      },
    },
  };
}

export function queryUppPayResult(data) {
  return {
    type: QUERY_UPPPAY_RESULT,
    payload: {
      request: {
        url: urlConfig.queryUppPayResult,
        method: 'post',
        data,
      },
    },
  };
}




// WEBPACK FOOTER //
// ./src/routes/routes/updateDetail/modules/actions.js